import { render, staticRenderFns } from "./SetupCard.vue?vue&type=template&id=49e7bc18&scoped=true&"
import script from "./SetupCard.vue?vue&type=script&lang=js&"
export * from "./SetupCard.vue?vue&type=script&lang=js&"
import style0 from "./SetupCard.vue?vue&type=style&index=0&id=49e7bc18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e7bc18",
  null
  
)

export default component.exports